// Moved unchanged out of CaseBriefPage.js (ticket 072). Old brief only.
import React from 'react'
import { SourceCardHeader } from './BriefParts'

export function DataConflictsCard({ conflicts }) {
  if (!conflicts || conflicts.length === 0) return null
  return (
    <div className="brief-source-card">
      <SourceCardHeader title="Data conflicts" sub="Confirmed profile vs. latest calculator run" />
      <div className="brief-source-card-body">
        <div className="brief-unconfirmed-list">
          {conflicts.map((c, i) => (
            <div key={i} className="brief-unconfirmed-row">
              <span className="brief-unconfirmed-fact"><strong>{c.field.replace(/_/g, ' ')}</strong></span>
              <span className="brief-unconfirmed-why">
                Confirmed: {String(c.confirmed_value)} · Calculator: {String(c.calculator_value)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
